import { render } from "./Indicator.vue?vue&type=template&id=0b3bf4a7"
import script from "./Indicator.vue?vue&type=script&setup=true&lang=js"
export * from "./Indicator.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Table/Fields/Indicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b3bf4a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b3bf4a7', __exports__)) {
    api.reload('0b3bf4a7', __exports__)
  }
  
  module.hot.accept("./Indicator.vue?vue&type=template&id=0b3bf4a7", () => {
    api.rerender('0b3bf4a7', render)
  })

}


export default __exports__